import { IUser } from "./user.models.types";

export enum KycType {
  GST = "gst",
  PAYOUT = "payout",
}

export enum KycStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
}

export interface IKycLogEntry {
  status: KycStatus;
  message: string | null;
  reviewedBy: IUser | null;
  createdAt: string;
}

export interface IPanLogEntry extends IKycLogEntry {
  pan: string;
  submittedName: string;
  fullName: string;
  verifiedAt?: string;
  hasGst?: boolean;
}

export interface IGstLogEntry extends IKycLogEntry {
  gst: string;
  businessName: string;
  legalName?: string;
  tradeName?: string;
}

// Creator-specific GST and PAN types (separate from vendor types)
export interface ICreatorGST {
  gst: string;
  businessName: string;
  timestamp: string;
  status: KycStatus;
  tradeName: string;
  legalName: string;
}

export interface ICreatorPAN {
  pan: string;
  fullName: string;
  submittedName: string;
  verifiedAt: string;
  status: KycStatus;
}
